var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 144,
    viewBox: "0 0 142 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2651_672)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8796 47.8679C99.7019 47.8668 100.505 47.6351 101.189 47.2021C101.872 46.7691 102.404 46.1542 102.718 45.4351C103.031 44.7161 103.113 43.9252 102.951 43.1624C102.79 42.3996 102.393 41.6991 101.811 41.1496C101.229 40.6 100.488 40.2261 99.6817 40.0749C98.875 39.9238 98.0391 40.0023 97.2797 40.3006C96.5202 40.5988 95.8712 41.1033 95.4148 41.7504C94.9584 42.3975 94.715 43.1581 94.7155 43.936C94.7168 44.9797 95.1562 45.9802 95.9371 46.7175C96.7179 47.4548 97.7763 47.8686 98.8796 47.8679Z",
    fill: "url(#paint0_linear_2651_672)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5037 74.8654L55.6616 67.8411C39.1432 55.6069 32.4572 78.3322 51.8328 76.1583L60.5037 74.8654Z",
    fill: "url(#paint1_linear_2651_672)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6066 67.8445C79.7471 53.4106 55.785 46.8391 58.1067 66.5509L62.1456 73.1292L67.6066 67.8445Z",
    fill: "url(#paint2_linear_2651_672)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6869 103.999L72.6765 91.1931L69.6869 79.0659H63.5781L56.1012 78.4531L54.6042 83.7923V101.488C54.6069 102.153 54.8875 102.79 55.3849 103.26C55.8823 103.73 56.5561 103.995 57.2592 103.997L69.6869 103.999Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7035 101.491V80.4696C94.7016 80.0978 94.5445 79.7417 94.2664 79.4789C93.9884 79.2161 93.6118 79.0678 93.2188 79.0664H79.6216L76.0677 91.5368L79.6223 104H92.0492C92.7521 103.998 93.4256 103.733 93.9228 103.263C94.42 102.793 94.7006 102.156 94.7035 101.491Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6058 67.8443C75.9376 57.9401 67.2632 51.7355 61.7554 55.1908C66.2945 55.4311 70.2247 60.5695 64.596 67.9628L65.2574 69.0801L67.6058 67.8443Z",
    fill: "url(#paint3_linear_2651_672)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6591 67.8412C46.234 60.8618 40.0122 65.2594 40 69.9232C41.9612 67.2386 46.5363 65.9607 52.7386 69.7516C52.9952 69.3733 53.3474 69.0614 53.7634 68.8441L55.6591 67.8412Z",
    fill: "url(#paint4_linear_2651_672)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6877 79.0664H79.6195V104H69.6877V79.0664Z",
    fill: "url(#paint5_linear_2651_672)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7037 85.1607V80.4696C94.7018 80.0978 94.5447 79.7417 94.2667 79.4789C93.9886 79.2161 93.6121 79.0678 93.219 79.0664H87.2283C87.6213 79.0678 87.9979 79.2161 88.2759 79.4789C88.554 79.7417 88.7111 80.0978 88.713 80.4696V101.49C88.7103 102.156 88.4291 102.794 87.9308 103.264C87.4325 103.734 86.7576 103.999 86.0537 104H92.0502C92.7533 103.998 93.4271 103.733 93.9245 103.263C94.4219 102.792 94.7025 102.155 94.7052 101.49V85.1607H94.7037Z",
    fill: "#2ED1E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2815 72.0089C52.1603 72.0089 52.0399 71.9889 51.926 71.9497C50.3295 71.3845 48.6586 71.0292 46.9601 70.8937C46.822 70.8824 46.6877 70.8452 46.5651 70.7841C46.4424 70.723 46.3339 70.6394 46.2459 70.538C46.1579 70.4367 46.0923 70.3198 46.0527 70.1941C46.0132 70.0685 46.0006 69.9366 46.0157 69.8063C46.0308 69.6759 46.0733 69.5497 46.1407 69.4352C46.2081 69.3206 46.299 69.2199 46.4081 69.1391C46.5172 69.0582 46.6423 68.9988 46.776 68.9643C46.9098 68.9298 47.0494 68.921 47.1868 68.9383C49.0507 69.0926 50.8842 69.4838 52.6378 70.1012C52.8661 70.1812 53.0575 70.3345 53.1786 70.5343C53.2998 70.7341 53.343 70.9678 53.3007 71.1947C53.2584 71.4215 53.1332 71.6272 52.9471 71.7757C52.761 71.9242 52.5257 72.0063 52.2822 72.0076L52.2815 72.0089Z",
    fill: "#FE0263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7493 66.6202C62.7214 66.6202 62.6936 66.6202 62.6658 66.6202C62.3908 66.5997 62.1357 66.4767 61.9566 66.2783C61.7775 66.0799 61.6891 65.8223 61.7107 65.5622C61.9443 63.6799 62.5871 61.8637 63.5985 60.2277C63.7454 60.0124 63.9753 59.8598 64.2394 59.8023C64.5034 59.7449 64.7807 59.7873 65.0123 59.9204C65.2438 60.0534 65.4113 60.2668 65.4792 60.5149C65.547 60.763 65.5098 61.0264 65.3754 61.249C64.5356 62.6227 63.9948 64.1416 63.7849 65.716C63.7638 65.9622 63.6455 66.1919 63.4536 66.3594C63.2618 66.5269 63.0103 66.62 62.7493 66.6202Z",
    fill: "#FE0263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0499 74.4101C86.8479 74.41 86.6503 74.3542 86.4812 74.2496C86.3122 74.145 86.179 73.9961 86.0979 73.8211C86.0169 73.646 85.9914 73.4525 86.0247 73.264C86.0581 73.0755 86.1487 72.9003 86.2856 72.7597C90.739 68.1981 89.4191 56.1682 89.4054 56.047C89.3907 55.9185 89.4029 55.7885 89.4413 55.6645C89.4797 55.5405 89.5436 55.4248 89.6292 55.3242C89.7148 55.2235 89.8206 55.1397 89.9405 55.0777C90.0603 55.0157 90.1919 54.9766 90.3277 54.9627C90.4635 54.9488 90.6009 54.9604 90.732 54.9967C90.8631 55.033 90.9854 55.0934 91.0918 55.1744C91.1982 55.2555 91.2867 55.3555 91.3523 55.4689C91.4178 55.5823 91.4591 55.7068 91.4738 55.8352C91.5343 56.3656 92.9024 68.8789 87.8149 74.0935C87.7175 74.1935 87.5992 74.2733 87.4675 74.3278C87.3358 74.3823 87.1936 74.4103 87.0499 74.4101Z",
    fill: "#E0D2CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5929 60.7032C97.4369 60.7032 97.2828 60.67 97.1421 60.6061C97.0015 60.5421 96.8778 60.4491 96.7803 60.3338C96.6828 60.2186 96.6139 60.084 96.5788 59.9402C96.5437 59.7964 96.5432 59.6469 96.5774 59.5028C97.0704 57.7543 97.8614 56.0935 98.9193 54.5858C101.146 51.271 104.653 48.909 108.692 48.002C108.826 47.9681 108.966 47.96 109.104 47.9782C109.241 47.9963 109.374 48.0404 109.493 48.1077C109.612 48.175 109.716 48.2642 109.798 48.37C109.88 48.4759 109.939 48.5963 109.972 48.7241C110.004 48.8518 110.009 48.9844 109.986 49.114C109.963 49.2436 109.913 49.3676 109.839 49.4786C109.765 49.5896 109.668 49.6854 109.554 49.7604C109.44 49.8354 109.311 49.888 109.175 49.9152C105.671 50.686 102.628 52.7285 100.702 55.6023C99.7632 56.9331 99.0556 58.3975 98.6062 59.9399C98.5531 60.1567 98.4241 60.35 98.2401 60.4886C98.0562 60.6271 97.8281 60.7028 97.5929 60.7032Z",
    fill: "#E0D2CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2668 48.5715L88.3086 46.245C88.7281 45.795 88.7001 45.6615 88.0826 45.5165L84.9109 44.7703C84.5511 44.6866 84.5316 44.5947 84.3539 44.3203L82.7518 41.7923C82.4287 41.2776 82.2315 41.2776 81.9047 41.7923L80.3049 44.3203C80.1314 44.5926 80.1069 44.6866 79.7478 44.7703L76.5768 45.5138C75.9637 45.6588 75.9291 45.7923 76.3509 46.2423L78.3962 48.5687C78.4949 48.6949 78.5655 48.8387 78.6036 48.9915C78.6417 49.1442 78.6465 49.3027 78.6179 49.4573L78.3718 52.3325C78.2998 52.9275 78.4365 52.9997 79.0252 52.775L81.8133 51.6768C82.147 51.5624 82.5125 51.5624 82.8461 51.6768L85.6378 52.775C86.2265 52.9997 86.3575 52.9275 86.2855 52.3325L86.0437 49.4573C86.0145 49.303 86.0192 49.1448 86.0576 48.9924C86.096 48.8399 86.1672 48.6967 86.2668 48.5715Z",
    fill: "url(#paint6_linear_2651_672)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.446 46.1706C82.1335 48.3703 81.3258 50.4809 80.0775 52.3601L81.8127 51.6793C82.1463 51.5649 82.5118 51.5649 82.8455 51.6793L85.6371 52.7775C86.2259 53.0022 86.3568 52.93 86.2849 52.335L86.043 49.4597C86.0133 49.3052 86.0177 49.1465 86.0558 48.9936C86.094 48.8407 86.1651 48.6969 86.2647 48.5712L88.3065 46.2448C88.7261 45.7947 88.698 45.6613 88.0805 45.5163L84.9095 44.7728C84.5497 44.6891 84.5303 44.5971 84.3525 44.3228L82.7505 41.7941C82.7071 41.7232 82.6591 41.655 82.6065 41.5898C82.7618 43.1181 82.7073 44.6589 82.4446 46.174L82.446 46.1706Z",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.61 71.1788L108.652 68.8523C109.075 68.4023 109.043 68.2689 108.426 68.1238L105.255 67.3804C104.9 67.2966 104.875 67.2047 104.702 66.9303L103.1 64.4017C102.773 63.8869 102.575 63.8869 102.253 64.4017L100.647 66.9303C100.474 67.2027 100.449 67.2966 100.094 67.3804L96.9235 68.1238C96.306 68.2689 96.2757 68.4023 96.6975 68.8523L98.7364 71.1788C98.836 71.3045 98.9071 71.4483 98.9453 71.6012C98.9834 71.754 98.9878 71.9127 98.958 72.0673L98.7119 74.9391C98.6471 75.5376 98.7767 75.6104 99.3654 75.3851L102.153 74.2869C102.489 74.1724 102.855 74.1724 103.191 74.2869L105.979 75.3851C106.567 75.6097 106.698 75.5376 106.632 74.9391L106.386 72.0673C106.357 71.9126 106.361 71.7538 106.4 71.6009C106.438 71.448 106.51 71.3043 106.61 71.1788Z",
    fill: "url(#paint7_linear_2651_672)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.793 68.7815C102.479 70.9817 101.669 73.0924 100.418 74.9711L102.153 74.2902C102.489 74.1758 102.855 74.1758 103.19 74.2902L105.979 75.3884C106.567 75.6131 106.698 75.5409 106.632 74.9425L106.386 72.0707C106.356 71.9161 106.361 71.7574 106.399 71.6045C106.437 71.4516 106.508 71.3078 106.608 71.1822L108.649 68.8557C109.073 68.4057 109.041 68.2722 108.423 68.1272L105.252 67.3837C104.898 67.3 104.873 67.2081 104.7 66.9337L103.098 64.405C103.053 64.3319 103.003 64.2619 102.949 64.1953C103.106 65.724 103.054 67.2655 102.793 68.7815Z",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.044 43.9356C103.043 43.2446 102.85 42.566 102.484 41.9678C102.118 41.3697 101.593 40.8731 100.96 40.5277C100.327 40.1823 99.61 40.0003 98.8795 40C98.1491 39.9997 97.4314 40.181 96.7985 40.5259C97.4312 40.8708 97.9567 41.3674 98.3221 41.9655C98.6875 42.5637 98.8798 43.2423 98.8798 43.9332C98.8798 44.624 98.6875 45.3027 98.3221 45.9008C97.9567 46.499 97.4312 46.9955 96.7985 47.3405C97.431 47.6851 98.1482 47.8665 98.8781 47.8664C99.608 47.8663 100.325 47.6848 100.958 47.3401C101.59 46.9953 102.116 46.4994 102.482 45.9021C102.848 45.3047 103.042 44.6268 103.044 43.9363V43.9356Z",
    fill: "url(#paint8_linear_2651_672)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0529 74.9847L60.8475 73.7646L65.2578 69.0818L63.8414 66.6832C63.5852 66.2466 63.207 65.885 62.7482 65.6381C62.3126 65.4024 61.8201 65.2768 61.3183 65.2735C60.8165 65.2702 60.3222 65.3892 59.8831 65.619L58.1105 66.5524L55.6635 67.8413L53.7621 68.8462C53.3447 69.0659 52.9911 69.3797 52.7327 69.7598C52.4743 70.1399 52.3191 70.5744 52.281 71.0249C52.2313 71.5654 52.355 72.1076 52.6358 72.5806L54.0529 74.9847Z",
    fill: "url(#paint9_linear_2651_672)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3534 76.0259L81.2398 69.7621C81.7113 69.5123 82.0592 69.0962 82.2075 68.6046C82.3559 68.1129 82.2926 67.5858 82.0315 67.1382L79.9213 63.561C79.6564 63.1152 79.2157 62.7867 78.6956 62.6474C78.1754 62.5081 77.6181 62.5692 77.1455 62.8175L67.6074 67.8442L65.259 69.0799V73.7628L69.3534 76.0259Z",
    fill: "#01D0FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2615 88.1928L58.148 81.929L58.4869 77.2461L54.0529 74.9844L51.8298 76.1588L42.1621 81.2482C41.6921 81.4983 41.3456 81.914 41.1982 82.4048C41.0509 82.8956 41.1146 83.4215 41.3755 83.8681L43.4857 87.4493C43.7518 87.8939 44.1925 88.2213 44.7121 88.3605C45.2318 88.4997 45.7885 88.4394 46.2615 88.1928Z",
    fill: "#01D0FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.596 67.9604L63.8418 66.6791C63.5856 66.2425 63.2074 65.8809 62.7486 65.634C62.313 65.3984 61.8207 65.2729 61.319 65.2696C60.8174 65.2663 60.3232 65.3852 59.8842 65.6149L58.1087 66.549L56.4225 67.4375C57.0969 67.0835 57.8921 66.9967 58.634 67.1962C59.3759 67.3956 60.004 67.8651 60.3808 68.5017L61.7972 70.9044L65.2589 69.0777L64.596 67.9604Z",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2374 69.7621C81.7089 69.5123 82.0568 69.0962 82.2051 68.6046C82.3534 68.1129 82.2901 67.5858 82.0291 67.1382L79.9189 63.561C79.654 63.1152 79.2133 62.7867 78.6932 62.6474C78.173 62.5081 77.6157 62.5692 77.1431 62.8175L72.3737 65.3305C72.8456 65.0819 73.4026 65.0205 73.9223 65.1599C74.442 65.2993 74.8821 65.628 75.1459 66.074L77.2561 69.6512C77.5172 70.0968 77.5819 70.622 77.4361 71.1126C77.2903 71.6031 76.9458 72.0194 76.4773 72.271L81.2374 69.7621Z",
    fill: "#00B1CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3532 76.0228L65.2581 69.0781L54.0532 74.9817L58.1483 81.9264C61.8885 79.9546 65.6129 77.9931 69.3532 76.0228Z",
    fill: "url(#paint10_linear_2651_672)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2651_672",
    x: 0,
    y: 0,
    width: 150,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 24,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2651_672"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.960784 0 0 0 0 0.470588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2651_672"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2651_672",
    result: "effect2_dropShadow_2651_672"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2651_672",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2651_672",
    x1: 98.8738,
    y1: 40,
    x2: 98.8738,
    y2: 47.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF63C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F40093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2651_672",
    x1: 50.254,
    y1: 64.2031,
    x2: 50.254,
    y2: 76.3061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF63C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F40093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2651_672",
    x1: 64.503,
    y1: 54.2266,
    x2: 64.503,
    y2: 73.1292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF63C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F40093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2651_672",
    x1: 66.4065,
    y1: 54.2266,
    x2: 66.4065,
    y2: 69.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF63C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F40093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2651_672",
    x1: 47.8295,
    y1: 64.2031,
    x2: 47.8295,
    y2: 69.9232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF63C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F40093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2651_672",
    x1: 74.6536,
    y1: 79.0664,
    x2: 74.6536,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF63C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F40093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2651_672",
    x1: 82.3295,
    y1: 41.4065,
    x2: 82.3295,
    y2: 61.4645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2651_672",
    x1: 102.675,
    y1: 64.0159,
    x2: 102.675,
    y2: 84.0753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2651_672",
    x1: 99.9212,
    y1: 40,
    x2: 99.9212,
    y2: 47.8664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF63C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F40093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2651_672",
    x1: 58.7635,
    y1: 65.2736,
    x2: 58.7635,
    y2: 82.2322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2651_672",
    x1: 61.7032,
    y1: 69.0781,
    x2: 61.7032,
    y2: 81.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF63C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F40093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FAC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.48f24ff3e828c0a138898f5170787fdd.svg";
export { ForwardRef as ReactComponent };